import React, { useContext, useEffect } from 'react'
import AdminTemplate from "../../components/admin/layouts/Template";
import Card from "../../components/common/Card";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import CardTitle from "../../components/common/AssessmentCardTitle";
import CardToolbar from "../../components/common/SelfGradeCardToolBar";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { Backdrop, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TemplateTab from './components/TemplateTab';
import SectionTab from './components/SectionTab';
import PartTab from './components/PartTab';
import { MainContext } from '../../context/main/main-context';

function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

function Template() {

    const {fetchTemplateMetaData} = useContext(MainContext)
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const handleGetTemplateMetaData = async()=>{
      try {
        await fetchTemplateMetaData?.()
      } catch (error) {
        console.error(error);
      }
    }

    useEffect(() => {
      handleGetTemplateMetaData()
    }, [])
    
  return (
        <AdminTemplate>

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                // open={assmnt_loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div style={{ height: "90vh", overflow: "auto" }}>
                <ContentWrapper>
  
                    <Card>
                        <CardHeader>
                            <CardTitle cardLabel="Manage Assessment Templates" />
                        </CardHeader>
                            <CardBody>

                                 <Box sx={{ bgcolor: 'background.paper' }}>
                                    {/* <AppBar position="static"> */}
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="fullWidth"
                                            aria-label="full width tabs example"
                                        >
                                        <Tab label="Template" {...a11yProps(0)} />
                                        <Tab label="Part" {...a11yProps(1)} />
                                        <Tab label="Section" {...a11yProps(2)} />
                                        </Tabs>
                                    {/* </AppBar> */}
                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                        <TemplateTab/>
                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>
                                        <PartTab/>
                                    </TabPanel>
                                    <TabPanel value={value} index={2} dir={theme.direction}>
                                        <SectionTab/>
                                    </TabPanel>
                                    </Box>

                            </CardBody>
                    </Card>
                </ContentWrapper>
            </div>
        </AdminTemplate>
    )
}

export default Template